import React from "react";
import "./Homepage.scss";

import Hero from "components/Hero";
import DisplayGrid from "components/DisplayGrid";
// import SectionTitle from "components/SectionTitle";
import Wrapper from "components/Wrapper";

import { withAuthentication, AuthUserContext } from "components/Session";
import { withFirebase } from "components/Firebase";
import { compose } from "recompose";

// const actions = [
//   {
//     label: "Featured",
//     type: "ghost"
//   },
//   {
//     label: "Most Liked",
//     type: "ghost"
//   },
//   {
//     label: "Most Viewed",
//     type: "ghost"
//   },
//   {
//     label: "Most Recent",
//     type: "ghost"
//   },
//   {
//     label: "Recommend a Project",
//     type: "primary",
//     to: "/recommend"
//   }
// ];

class Homepage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      user: null
    };
  }
  componentDidMount() {
    const { projects } = this.state;
    this.props.firebase
      .projects()
      .limit(9)
      .get()
      .then(({ docs }) => {
        docs.map((doc, i) => {
          // console.log(doc.data());
          projects.push(doc.data());
          this.setState({ projects });
          return true;
        });
      })
      .catch(error => console.error(error));
  }
  render() {
    const { projects } = this.state;

    return (
      <div className="Homepage">
        {/* {this.state.auth} */}
        <AuthUserContext.Consumer>
          {authUser => (
            <>
              {/* {authUser ? null : (
                <>
                  <Hero />
                  <HowItWorks />
                </> */}
              <Hero user={authUser} projects={projects} />
              {/* <HowItWorks />

              {/* <div style={{ margin: "auto", width: 1232 }}>
                <br />
                <br />
                <br />
                <br />

                {/* <DisplayGrid title="Trending" actions={actions} /> */}
              {projects && projects.length > 0 && (
                <Wrapper width={1232} center>
                  <DisplayGrid
                    title="Recently Added"
                    projects={projects}
                    // actions={actions}
                  />
                </Wrapper>
              )}
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </>
          )}
        </AuthUserContext.Consumer>
      </div>
    );
  }
}

// const condition = authUser => authUser;

export default compose(
  withFirebase,
  withAuthentication
  // withAuthorization()
)(Homepage);
